import React, {useState} from "react";
import { useNavigate  } from "react-router-dom";
import { TitledHeader } from "../headers";
import { Button, Col, Alert } from 'react-bootstrap';
import Form  from 'react-bootstrap/Form';
import { TitledPageChange, GetUser } from '..';
import ReCAPTCHA from "react-google-recaptcha";
import { post } from "react-restfully";
import {LoadingSpinner, UserContext} from '..';
import $ from 'jquery';
import queryString from 'query-string';

function ResetPassword() {
    const reset_password_token = queryString.parse(window.location.search).reset_password_token;
    
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitStatus, setSubmitStatus] = useState("");
    const [submitStatusState, setSubmitStatusState] = useState("danger");
    
    const handleSubmit = (event) => {
        var oldpassword = $("#oldpassword");
        $("#formpassword2")[0].setCustomValidity("");
        
        event.preventDefault();
        event.stopPropagation();
        
        const form = event.currentTarget;
        let valid = form.checkValidity();
        
        if (password !== password2) {
            $("#formpassword2")[0].setCustomValidity("NOT EQUAL")
            valid = false;
        } else {
            $("#formpassword2")[0].setCustomValidity("")
        }
        
        setValidated(true);
  
        if (valid) {         
            let body =  {
                "reset_password_token":  reset_password_token, 
                "password":  password, 
                "password_confirmation":  password2
            };
            
            setSubmitStatus(false);
            setLoading(true);
            post('/api/resetpassword', {
                payload: body,
                headers: 
                    {
                        "Content-Type": "application/json"
                    }
            }).then(data => {
                if (data.status===0) {
                    setSubmitStatusState("success");
                    setSubmitStatus("Your password has been updated.");
                    setValidated(false);
                } else {
                    setSubmitStatusState("danger");
                    setSubmitStatus(data.message);
                }
                
                setLoading(false);
            }).catch(err =>{
                setSubmitStatusState("danger");
                setSubmitStatus("Unknown Error");
                setLoading(false);
            });
        }
    };
    
    const navigate = useNavigate();
    
    const showAlert = () => {
        if (submitStatus && submitStatus.length) {
            return (
                <Alert variant={submitStatusState}>
                    {submitStatus}
                </Alert>
            );
        }
    }
    
    const signInCover = "url("+getComputedStyle(document.documentElement).getPropertyValue('--signin-background')+")";
  return (
        <>
        <LoadingSpinner active={loading} text="test loader" className="loading-overlay"></LoadingSpinner>
        <  div className="signin-cover" style={{backgroundImage: signInCover}}></div>
            <div className="filled">
                <div className="signin">
                    <div className="container">
                        <div className="signin-container">
                            <div className="signin-form">
                                <Form noValidate  validated={validated} onSubmit={(evt) => {handleSubmit(evt);}}>
                                    <h3>Reset Your Password</h3>
                                        {
                                            showAlert()
                                        }
                                    
                                    <Form.Group controlId="formpassword" className="mb-3">
                                        <Form.Control required type="password" placeholder="New Password" minLength="6"
                                            value={password} onChange={(e) => setPassword(e.target.value)}/>
                                        <Form.Control.Feedback type="invalid">Password must be at least 6 characters.</Form.Control.Feedback>
                                    </Form.Group>
                                    
                                    <Form.Group controlId="formpassword2" className="mb-3">
                                        <Form.Control type="password" placeholder="New Password (again)"
                                            value={password2} onChange={(e) => setPassword2(e.target.value)}/>
                                        <Form.Control.Feedback type="invalid">Passwords must match.</Form.Control.Feedback>
                                    </Form.Group>
                                    
                                    
                                    <div className="mb-3">
                                        <button className={"button-action"}>Update Password</button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
  );
}

export default ResetPassword;
